import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { GetCampaignContentFnResponse } from '../types/campaign';
import { GetCampaignContent } from '../helpers/get-campaign-content';

interface GetCampaignContentForConfirmationFnPayload {
    campaignId?: string;
}

export type GetCampaignContentForConfirmationFn = (
    payload: GetCampaignContentForConfirmationFnPayload,
) => Promise<GetCampaignContentFnResponse>;

export function initGetCampaignContentForConfirmationFn({
    dependencies,
    locale,
    countryCodeDefault,
}: DomainInitPayload): GetCampaignContentForConfirmationFn {
    return async ({
        campaignId,
    }: GetCampaignContentForConfirmationFnPayload) => {
        if (!campaignId) {
            campaignId =
                countryCodeDefault === 'ca'
                    ? 'CA_default_conf_campaign'
                    : 'default_conf_campaign';
        }
        return await GetCampaignContent(dependencies, {
            campaignId,
            locale,
        });
    };
}
